/**
 * Cookie/tracking consent categories.
 *
 * Domain-agnostic primitives — no product-specific labels live here. Consuming
 * apps supply the user-facing copy. Three categories only: a single analytics
 * vendor (PostHog) plus an elevated-sensitivity session-replay category.
 */

export const CONSENT_COOKIE_NAME = "eg-consent";
export const CONSENT_RECEIPT_KEY = "eg-consent-receipt";

/** Re-prompt window — consent expires after 12 months. */
export const CONSENT_TTL_DAYS = 365;

export type ConsentCategoryId = "essential" | "analytics" | "sessionReplay";

export interface ConsentCategories {
  /** Always granted — session cookies, theme, layout. Cannot be disabled. */
  essential: true;
  /** PostHog event capture: pageviews, web vitals, exceptions. */
  analytics: boolean;
  /** Session replay + console-log capture. Off by default even if analytics on. */
  sessionReplay: boolean;
}

export type ConsentDecision = "accepted" | "rejected" | "customised" | "gpc";

export interface ConsentState {
  categories: ConsentCategories;
  decision: ConsentDecision;
  /** ISO8601 timestamp of the recorded decision. */
  decidedAt: string;
  /** Privacy/cookie policy version the decision was made against. */
  policyVersion: string;
}

/** Default-denied: nothing non-essential before an explicit choice. */
export function defaultCategories(): ConsentCategories {
  return { essential: true, analytics: false, sessionReplay: false };
}

export function fullCategories(): ConsentCategories {
  return { essential: true, analytics: true, sessionReplay: true };
}
